import ListField from './ListField'
const Experience = props => (
   <ListField
      {...props}
      label="Experience"
      fieldKey="experience"
      placeholder="Role or achievement…"
   />
)
export default Experience
